import React from 'react';
import FavoriteIcon from '../../icons/FavoriteIcon';
import Typography from '../Typography';
import { Wrapper } from './styles';

type FavoriteToastProps = {
  message: string;
  visable: boolean;
  size?: 'default' | 'small';
  parentWidth?: number;
};

const FavoriteToast = ({
  message,
  visable,
  size,
  parentWidth,
}: FavoriteToastProps) => {
  return (
    <Wrapper visable={visable} size={size} parentWidth={parentWidth}>
      <FavoriteIcon variant="filled" color="#fff" />
      <Typography variant="utility1" color="#fff">
        {message}
      </Typography>
    </Wrapper>
  );
};

export default FavoriteToast;
